<span [class]="'eventq-ai-event-tag eventq-ai-event-tag--' + variant()">
  <img class="eventq-ai-event-tag__icon" [src]="iconSrc()" alt="" />
  <span class="eventq-ai-event-tag__label">{{ label() }}</span>
</span>
